import __request__ from "routing/request";
export function get(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.archive/index_sets/archive_settings", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
